<template>
    <div v-if="trainerPosition" class="mfw-root" :style="bgStyle">
        <div class="mfw-content">
            <div class="mfw-top-row">
                <div class="mfw-square-tile" :class="{'mfw-square-tile--disabled': isLoading}" @click="!isLoading && backToCity()">
                    <div class="mfw-back-badge-img" :style="cityImgStyle"/>
                    <div class="mfw-square-label">{{ $t('common.backToCity') }}</div>
                </div>
                <!-- žádný druhý čtvereček (Mewtwo nemá obstacle-hint), placeholder drží stejný dvousloupcový výškový rozpočet -->
                <div class="mfw-square-placeholder"/>
            </div>

            <div class="mfw-congrats-card" :class="$vuetify.theme.dark ? 'transparent03--dark white--text' : 'transparent03 black--text'">
                <div class="mfw-badge-block">
                    <div class="mfw-congrats-title">{{ $t('common.congratulations') }}</div>
                    <div class="mfw-congrats-subtitle">{{ $t('journey.mewtwoFightWin.congratsSubtitle') }}</div>
                    <div class="mfw-badge-img-wrap">
                        <v-img
                            src="@/assets/pic/badge/9.png"
                            class="mfw-badge-img"
                            height="100%"
                            contain
                        />
                    </div>
                    <div class="mfw-giovanni-row">
                        <v-img
                            src="@/assets/pic/trainer/8.png"
                            class="mfw-giovanni-img"
                            contain
                        />
                        <div class="mfw-giovanni-msg">
                            {{ $t('journey.mewtwoFightWin.giovanniMessage') }}
                        </div>
                    </div>
                </div>
                <div class="mfw-toplist-scroll">
                    <ToplistTable
                        :toplist="toplist"
                        :headers="[$t('journey.mewtwoFightWin.headerTrainer'), $t('journey.mewtwoFightWin.headerDay'), $t('journey.mewtwoFightWin.headerRound'), $t('journey.mewtwoFightWin.headerDate')]"
                        :keys="['trainer','day','round','created']"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // Fork win obrazovky po poražení Mewtwo/Giovanniho - stará
    // `MewtwoFightWin.vue` zůstává zmrazená/referenční za `!flags.newUi`.
    // Stejná kostra jako `TrainerFightWinNext.vue`, rozdíly viz
    // claude/components/journey-oak-league.md.
    import {mapActions, mapGetters} from 'vuex';
    import * as journeyApi from '@/api/journeyApi';
    import ToplistTable from '@/components/journey/positions/pieces/ToplistTable';

    const VIRIDIAN_CITY_ID = 9;
    const TEAM_ROCKET_BADGE_ID = 9;

    export default {
        name: 'MewtwoFightWinNext',
        components: {ToplistTable},
        props: {
            trainerPosition: {type: Object, default: null},
        },
        data() {
            return {
                toplist: [],
            }
        },
        computed: {
            ...mapGetters({
                isLoading: 'journey/isLoading',
            }),
            bgStyle() {
                return {backgroundImage: `url(${require('@/assets/pic/position/MEWTWO_FIGHT.png')})`};
            },
            cityImgStyle() {
                return {backgroundImage: `url(${require('@/assets/pic/city/' + VIRIDIAN_CITY_ID + '.png')})`};
            },
        },
        created() {
            this.getToplist();
            // výhra nad Mewtwem propouští ukradené pokémony zpět do rosteru (FightAction.php), ale samotný útok
            // dělá jen lehký HP patch bojujícího pokémona - plný refetch tady, ať se propuštění projeví v teamboardu
            this.refreshActiveTeam();
        },
        methods: {
            ...mapActions({
                fetchData: 'journey/fetchObject',
                positionPost: 'journey/positionPost',
                refreshActiveTeam: 'pokemon/refreshActiveTeam',
            }),
            backToCity() {
                this.positionPost(journeyApi.travel(this.trainerPosition.id, VIRIDIAN_CITY_ID));
            },
            getToplist() {
                this.fetchData(journeyApi.badgeToplist(TEAM_ROCKET_BADGE_ID)).then((data) => {
                    this.toplist = data['member'];
                });
            },
        },
    }
</script>

<style scoped>
.mfw-root {
    position: fixed;
    inset: 0;
    height: 100%;
    background-size: cover;
    background-position: center;
    overflow-y: auto;
}
.mfw-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    /* bottom 54px = rezerva pro globální TeamBottomSheet - .mfw-root je "position: fixed; inset: 0" */
    padding: 74px 16px 54px 16px;
    height: 100%;
    box-sizing: border-box;
}
.mfw-top-row {
    width: 100%;
    max-width: 420px;
    flex: 0 3 25%;
    min-height: 20%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    justify-items: stretch;
}
.mfw-square-tile {
    width: 100%;
    height: 100%;
    container-type: inline-size;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
}
.mfw-square-tile--disabled {
    pointer-events: none;
    opacity: 0.6;
}
.mfw-square-placeholder {
    width: 100%;
}
.mfw-back-badge-img {
    flex: 1 1 auto;
    min-height: 0;
    width: auto;
    max-width: 100%;
    aspect-ratio: 1;
    border-radius: 14px;
    background-size: cover;
    background-position: center;
    border: 5px solid #C0C0C0;
    box-shadow: 0 3px 8px rgba(0,0,0,0.5);
    box-sizing: border-box;
}
.mfw-square-label {
    margin-top: -14px;
    position: relative;
    z-index: 1;
    background: rgba(0,0,0,0.65);
    color: #fff;
    font-size: clamp(15px, 15cqw, 30px);
    font-weight: 700;
    padding: 2px 8px;
    border-radius: 10px;
    text-shadow: 1px 1px 2px rgba(0,0,0,0.6);
    white-space: nowrap;
}
/* jedna karta pro congrats+odznak+Giovanni+žebříček, žádný samostatný "Glory list" nadpis -
   .mfw-badge-block a .mfw-toplist-scroll se dělí o místo v kartě 50/50 (`flex: 1 1 0` na obou) */
.mfw-congrats-card {
    width: 100%;
    max-width: 420px;
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    border-radius: 18px;
    padding: 6px 16px 10px 16px;
    text-align: center;
    box-shadow: 2px 3px 10px rgba(0,0,0,0.35);
    box-sizing: border-box;
}
.mfw-badge-block {
    flex: 1 1 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
}
.mfw-congrats-title {
    flex: none;
    font-size: 26px;
    font-weight: 800;
}
.mfw-congrats-subtitle {
    flex: none;
    font-size: 18px;
    font-weight: 600;
    margin-top: 2px;
}
.mfw-badge-img-wrap {
    flex: 1 1 auto;
    min-height: 0;
    margin-top: 6px;
}
.mfw-badge-img {
    height: 100%;
    width: 100%;
}
.mfw-giovanni-row {
    flex: none;
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 10px;
    text-align: left;
}
.mfw-giovanni-img {
    flex: 0 0 30%;
    max-width: 30%;
    max-height: 90px;
}
.mfw-giovanni-msg {
    flex: 1 1 auto;
    min-width: 0;
    font-size: 13px;
    font-weight: 600;
}
.mfw-toplist-scroll {
    flex: 1 1 0;
    min-height: 0;
    margin-top: 8px;
    overflow-y: auto;
}
</style>
